export default "/50f517735fec46580f19aae3e56e9fe21614ea75/a70fe28c30edbe909cade8425716fdee.svg";